import { createContext } from "react";

export const MoneyGlobalTab = [];

export const AppContext = createContext(MoneyGlobalTab);